module.exports = __webpack_public_path__ + "img/gt.656c9899.svg";